import { ReactNode } from 'react';
import { usePreferences as usePreferencesHook } from '@/hooks/usePreferences';
import { PreferencesContext } from './preferences.context';

export function PreferencesProvider({ children }: { children: ReactNode }) {
  const preferencesData = usePreferencesHook();

  return (
    <PreferencesContext.Provider value={preferencesData}>
      {children}
    </PreferencesContext.Provider>
  );
}
